import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateValePedagioTaxasActions } from "store/ducks/settings/vale-pedagio-taxas";

export function* paginateValePedagioTaxasRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);
    
    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/vale-pedagio-taxas?${queryString}`
    );

    const { data, ...pagination } = responseBody;
    yield put(PaginateValePedagioTaxasActions.success(data, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateValePedagioTaxasActions.failure(errorMessage));
  }
}